(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion-section"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.faq-question').forEach((question) => {
  question.addEventListener('click', function () {
    const item = this.parentElement;
    item.classList.toggle('active');
  });
});

  } catch(e) { console.error(e); }
})();
})();
